import './index.scss';

/*
* Uncomment the code below to enable front end JS for your block
*/

/*

document.addEventListener('DOMContentLoaded', function(){
  
  function handleCustomBlock(block){
    // Main block logic goes here...
    // const example = block.querySelectorAll('.example')
  }

  const blockInstances = document.querySelectorAll('.pd-block-reverse-hero')

  if(!!blockInstances && blockInstances.length > 0){
    blockInstances.forEach(block => {
      handleCustomBlock(block)
    })
  }

})

*/